export default __webpack_public_path__ + "static/media/storageUnit1-afterC-768w.d4b1cd7a.avif";